import { CustomerActivityType } from "@redotech/redo-model/marketing/segments/segment-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getTokenFieldOptions = {
  name: "getTokenFieldOptions" as const,
  input: z.object({
    dataStructureType: createEnum(CustomerActivityType),
    dataStructureField: z.string(),
    searchString: z.string().optional(),
  }),
  output: z.object({ items: z.array(z.string()) }),
};
